export const ERRORS = [];

export const IMAGE_RECOMMENDED_WIDTH = 1920;
export const IMAGE_RECOMMENDED_HEIGHT = 1080;
